import React from 'react';

import TitleBold from 'components/Typography/TitleBold';
import SubtitleRegular from 'components/Typography/SubtitleRegular';

/**
 * Placeholder das abas de Informe ainda não implementadas (DESSEM, Comparador).
 * Mostra o título da aba e uma mensagem de "em construção".
 */
export default function RelatorioEmConstrucao({ titulo }: { titulo: string }) {
  return (
    <div className="p-4">
      <TitleBold>{titulo}</TitleBold>
      <SubtitleRegular>Esta seção está em construção.</SubtitleRegular>
    </div>
  );
}
